import axios from './utils/axios';

export var select = function select(email, calendarId) {
  var encodedCalendarId = encodeURIComponent(calendarId);
  var endpoint = '/calendar-list/select/' + email + '/' + encodedCalendarId;
  return axios.post(endpoint);
};

export var unselect = function unselect(email, calendarId) {
  var encodedCalendarId = encodeURIComponent(calendarId);
  var endpoint = '/calendar-list/unselect/' + email + '/' + encodedCalendarId;
  return axios.post(endpoint);
};
//# sourceMappingURL=calendarlist.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/calendarlist.js
// module id = 1074
// module chunks = 0